import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poeissueApi = api
  .enhanceEndpoints({ addTagTypes: ['POEIssue'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOEIssues: builder.query<po_eissue[], string>({
        query: cid => `poeissue/${cid}`,
        providesTags: ['POEIssue']
      }),
      getPOEIssueByTable: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poeissue/bytbl/${cid}/${tbl}`,
        providesTags: ['POEIssue']
      }),
      getPOKOTs: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poeissue/bytblkots/${cid}/${tbl}`,
        providesTags: ['POEIssue']
      }),
      getPOEIssueById: builder.query<po_eissue, string>({
        query: id => `poeissue/byid/${id}`,
        providesTags: ['POEIssue']
      }),
      insertPOEIssue: builder.mutation({
        query: POEIssue => ({
          url: `poeissue/`,
          method: 'POST',
          body: POEIssue
        }),
        invalidatesTags: ['POEIssue']
      }),
      updatePOEIssue: builder.mutation({
        query: POEIssue => ({
          url: `poeissue/`,
          method: 'PUT',
          body: POEIssue
        }),
        invalidatesTags: ['POEIssue']
      }),
      deletePOEIssue: builder.mutation({
        query: POEIssue => ({
          url: `poeissue/${POEIssue.on_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POEIssue']
      }),
      getAvailableExcessStock: builder.query<any[], any>({
        query: params => {
          const outlet = typeof params === 'object' ? params.outlet : params;
          return `poeissue/excess-available/${outlet}`;
        },
        providesTags: ['POEIssue']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOEIssuesQuery,
  useGetPOEIssueByTableQuery,
  useGetPOKOTsQuery,
  useGetPOEIssueByIdQuery,
  useInsertPOEIssueMutation,
  useUpdatePOEIssueMutation,
  useDeletePOEIssueMutation,
  useGetAvailableExcessStockQuery
} = poeissueApi;


